// extracted by mini-css-extract-plugin
export var blockquote = "PO4qq";
export var blockquoteParagraph = "ash9r";